<template>
  <div class="beacon-list-container">
    <el-row>
      <div class="tfam-table-search">
        <span class="ti-search"></span>
        <input v-model="searchKey" class="form-control" aria-describedby="addon-right addon-left" placeholder="搜尋">
      </div>
    </el-row>
    <el-row>
      <el-table
        :data="showBeaconList"
        v-loading="listLoading"
        :show-header="false"
        :row-style="rowStyle"
        empty-text="無資料"
        @cell-mouse-enter="cellMouseEnter"
        @cell-mouse-leave="cellMouseLeave"
        style="width: 100%;">
        <el-table-column
          prop="status"
          label="status"
          width="50">
          <template slot-scope="scope">
            <div
              :class="{ active: scope.row['binding_type'] }"
              class="beacon-status-dot"></div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="name"
          width="180">
          <template slot-scope="scope">
            <div class="beacon-name" @click="goBeacon(scope.row['beacon_id'])">
              <span class="beacon-title">{{ scope.row.title }}</span>
              <br>
              <span class="beacon-status">{{ scope.row['binding_type'] ? '使用中' : '閒置' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          label="type"
          width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.type | typeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="event"
          label="event"
          min-width="130">
          <template slot-scope="scope">
            <div class="event-block">
              <div class="beacon-delete-block">
                <!--
                v-if="scope.row['binding_type'] && currentHoverRow === scope.row['beacon_id']"
                -->
                <span
                  v-if="scope.row['binding_type'] && currentHoverRow === scope.row['beacon_id']"
                  class="tfam-del"
                  v-loading.fullscreen.lock="fullScreenLoading"
                  @click="clearBinding(scope.row['title'], scope.row['beacon_id'])">
              </span>
              </div>
              <div
                class="beacon-events"
                :class="{ active: scope.row['binding_type'] }">
                <span class="tfam-link">{{ scope.row | filterBindingName }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination
        :page-size="10"
        :pager-count="11"
        :hide-on-single-page="true"
        :current-page.sync="listQuery.page"
        :total="beaconList.length"
        layout="prev, pager, next"
        @current-change="handleFilter">
      </el-pagination>
    </el-row>
    <div class="create-new" @click="createNew()">
      <span class="tfam-new"></span>
    </div>
  </div>
</template>

<script>
  import { fetchBeaconList, updateBeacon } from "../../api/beacon";
  import { fetchCollection, fetchCollectionList } from "../../api/collection";
  import { fetchBeaconMessage } from "../../api/beaconMessage";

  export default {
    name: "BeaconList",
    data() {
      return {
        enableTransfer: this.$store.getters.user.name === 'rideawavefun',
        showBeaconList: [],
        beaconList: [],
        listQuery: {
          page: 1
        },
        searchKey: '',
        listLoading: false,
        currentHoverRow: '',
        fullScreenLoading: false
      }
    },
    filters: {
      typeFilter: function (type) {
        if (type === 'collection') {
          return '展品'
        } else if (type === 'beaconMessage') {
          return '訊息'
        } else {
          return ''
        }
      },
      filterBindingName: function (row) {
        if (row['binding_type'] === 'collection' && row['collection']) {
          return row['collection']['collectionLangs'][0]['title'];
        } else if (row['binding_type'] === 'beaconMessage' && row['beaconMessage']) {
          return row['beaconMessage']['title'];
        } else {
          return '未綁定';
        }
      }
    },
    watch: {
      searchKey: function (val) {
        if (val && val.trim().length > 0) {
          this.showBeaconList = this.beaconList.filter(x => x['title'].includes(this.searchKey))
        } else {
          this.handleFilter()
        }
      }
    },
    computed: {
      rowStyle: function () {
        return {
          height: '80px',
          cursor: 'default'
        }
      }
    },
    methods: {
      cellMouseEnter(row, column, cell, event) {
        this.currentHoverRow = row['beacon_id']
      },
      cellMouseLeave(row, column, cell, event) {
        if (row['beacon_id'] === this.currentHoverRow) {
          this.currentHoverRow = ''
        }
      },
      clearBinding(beaconName, beaconId) {
        this.$confirm('確定要取消' + beaconName + '綁定事件?', '提示', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.fullScreenLoading = true;
          updateBeacon(beaconId, {
            object_id: null,
            binding_type: null
          }).then(response => {
            this.fullScreenLoading = false;
            this.$message({
              type: 'success',
              message: '取消綁定成功!'
            });
            this.getBeacons();
          }).catch(err => {
            this.fullScreenLoading = false;
          });
        }).catch(() => {
        });
      },
      handleFilter() {
        this.showBeaconList = this.beaconList.slice(
          (this.listQuery.page - 1) * 10, (this.listQuery.page) * 10);
      },
      getBeacons() {
        const filter = {
          order: ['title ASC']
        };
        this.listLoading = true;
        fetchBeaconList(filter).then(response => {
          this.getBeaconBindingData(response.data).then(beaconList => {
            this.listLoading = false;
            this.beaconList = beaconList;
            this.handleFilter();
          }).catch(bindingErr => {
            this.listLoading = false;
            this.beaconList = response.data;
          });
        }).catch(err => {
          this.listLoading = false;
        })
      },
      getBeaconBindingData: async function(beaconList) {
        try {
          for (const i in beaconList) {
            const beacon = beaconList[i];
            if (beacon['binding_type'] === 'collection' && beacon['object_id']) {
              const collectionResult = await fetchCollectionList({
                where: {
                  collection_id: beacon['object_id']
                },
                include: [{
                  relation: 'collectionLangs',
                  scope: {
                    where: {
                      'language_key': 'ZH_TW'
                    }
                  }
                }]
              });
              if (collectionResult.data.length > 0) {
                beacon['collection'] = collectionResult.data[0];
              }
            } else if (beacon['binding_type'] === 'beaconMessage' && beacon['object_id']) {
              const messageData = await fetchBeaconMessage(beacon['object_id']);
              beacon['beaconMessage'] = messageData.data;
            }
          }
          return Promise.resolve(beaconList);
        } catch (e) {
          return Promise.reject(e);
        }
      },
      goBeacon(id) {
        this.$router.push({
          path: '/beacons/' + id
        })
      },
      createNew() {
        this.goBeacon('new')
      },
      update: async function() {
        try {
          const beaconResult = await fetchBeaconList();
          const beaconList = beaconResult.data;
          const promiseArray = [];
          beaconList.forEach(beacon => {
            const uuid = beacon['uuid'];
            const major = uuid.substring(0, 5);
            const minor = uuid.substring(5, 10);
            promiseArray.push(updateBeacon(beacon['beacon_id'], {
              major,
              minor
            }))
          });
          await Promise.all(promiseArray);
          return Promise.resolve(true);
        } catch (e) {
          return Promise.reject(e);
        }
      }
    },
    mounted() {
      this.getBeacons();
      // this.listLoading = true;
      // this.update().then(response => {
      //   console.log(response);
      //   this.listLoading = false;
      // }).catch(err => {
      //   console.log(err);
      //   this.listLoading = false;
      // })
    }
  }
</script>

<style lang="scss">
.beacon-list-container {
  .beacon-status-dot {
    width: 10px;
    height: 10px;
    border-radius: 5px;
    margin: auto;
    background: #E56960;
  }
  .beacon-status-dot.active {
    background: #82C9A6;
  }
  .beacon-name {
    width: fit-content;
    cursor: pointer;
    .beacon-title {
      color: black;
      font-size: 15pt;
    }
    .beacon-status {
      font-size: 12pt;
    }
  }
  .el-pagination {
    float: right;
    .btn-prev {
      background: rgba(0, 0, 0, 0.01);
    }
    .el-dialog, .el-pager li {
      background: rgba(0, 0, 0, 0.01);
    }
    .btn-next {
      background: rgba(0, 0, 0, 0.01);
    }
  }
  .event-block {
    text-align: right;
    .beacon-delete-block {
      width: 40px;
      float: right;
      .tfam-del {
        line-height: 25px;
        color: darkgray;
        margin-right: 10px;
        cursor: pointer;
        font-size: 20px;
      }
      .tfam-del:hover {
        color: red;
      }
    }
    .beacon-events {
      cursor: default;
      span {
        cursor: default;
      }
    }
    .beacon-events:hover {
      border-color: rgba(255, 255, 255, 0.1);
      span {
        color: darkgray;
      }
    }
  }
}
</style>
